// extracted by mini-css-extract-plugin
module.exports = {"PatternBackground":"PatternBackground--1VMfk","PatternBackground--withOverflow":"PatternBackground--withOverflow--18n_O"};